// extracted by mini-css-extract-plugin
module.exports = {"container":"Login_container__3PcGN","card":"Login_card__3MKQX","form":"Login_form__3mQ3_","logo":"Login_logo__3IxLN"};